// Tabla centralizada de niveles. Hay 10 niveles en total.
// LEVEL_CAPS[i] = XP total que completa el nivel i+1 (y desbloquea el siguiente).
const LEVEL_CAPS: readonly number[] = [
  100,    // Nivel 1:    0 – 99
  400,    // Nivel 2:  100 – 399
  1050,   // Nivel 3:  400 – 1049
  2200,   // Nivel 4: 1050 – 2199
  4000,   // Nivel 5: 2200 – 3999
  6600,   // Nivel 6: 4000 – 6599
  10150,  // Nivel 7: 6600 – 10149
  14800,  // Nivel 8: 10150 – 14799
  20700,  // Nivel 9: 14800 – 20699
  28000,  // Nivel 10: 20700 – 28000 (tope)
];

export const MAX_LEVEL = LEVEL_CAPS.length; // 10

/** XP mínimo para estar en ese nivel (1-based). */
export const getLevelStartExp = (nivel: number): number => {
  const n = Math.min(Math.max(nivel, 1), MAX_LEVEL);
  return n === 1 ? 0 : LEVEL_CAPS[n - 2];
};

/** Dado un CurrentExp, devuelve el nivel (1 a 10). */
export const getLevelFromExp = (currentExp: number): number => {
  const exp = Math.max(0, currentExp || 0);
  for (let i = 0; i < LEVEL_CAPS.length; i++) {
    if (exp < LEVEL_CAPS[i]) return i + 1;
  }
  return MAX_LEVEL; // 28000 o más: se queda en 10
};

/** XP que completa el nivel dado (el "tope" de la barra). */
export const getExpCapForLevel = (nivel: number): number => {
  const n = Math.min(Math.max(nivel, 1), MAX_LEVEL);
  return LEVEL_CAPS[n - 1];
};

/** Progreso (0-100) dentro del nivel actual. */
export const getExpProgress = (nivel: number, currentExp: number): number => {
  const start = getLevelStartExp(nivel);
  const cap = getExpCapForLevel(nivel);
  const span = cap - start;
  if (span <= 0) return 0;
  return Math.min(100, Math.max(0, ((currentExp - start) / span) * 100));
};